import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectPartnerSiteTheme } from '../actions';
import ThemeCard from './index';

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      selectPartnerSiteTheme,
    },
    dispatch,
  ),
});

const connector = connect(null, mapDispatchToProps);

export default connector(ThemeCard);
